import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';

import SectionTitle from '../../../../components/section-title/SectionTitle';
import { changeGenerateTab } from '../../../../../../redux/activ8/activ8MessagesReducer';
import { changeActiv8Tab } from '../../../../../../redux/activ8/activ8Reducer';
import { ACTIV8_MESSAGE_GENERATE_TABS, ACTIV8_TABS } from '../../../../../../constants';
import CommonButtonLink from '../../../../../../components/common-button-link/CommonButtonLink';
import { BUTTON_STYLES } from '../../../../../../components/common-button/CommonButton';
import { setAddMessageToStoryMode } from '../../../../../../redux/story/storyReducer';

function MessageHeader() {
  const dispatch = useDispatch();
  const { t } = useTranslation('story');

  const handleRedirectToTheSavedMessages = () => {
    dispatch(setAddMessageToStoryMode(true));
    dispatch(changeActiv8Tab(ACTIV8_TABS.MESSAGES));
    dispatch(changeGenerateTab(ACTIV8_MESSAGE_GENERATE_TABS.SAVED));
  };

  return (
    <SectionTitle title={t('message')}>
      <CommonButtonLink
        onClick={handleRedirectToTheSavedMessages}
        styleColor={BUTTON_STYLES.PRIMARY}
        LeftIcon={BookmarkBorderOutlinedIcon}>
        {t('addFromSaved')}
      </CommonButtonLink>
    </SectionTitle>
  );
}

export default MessageHeader;
